import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  modal: {
    position: "absolute",
    width: "100%",
    maxWidth: "400px",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(6, 4, 3, 4),
    top: "50%",
    left: "50%",
    transform: "translate(-50%,-50%)",
    borderRadius: "33px",
    outline: "none",
    border: "none",
    textAlign: "center",
  },
  modalSmall: {
    maxWidth: "300px",
  },
  modalMedium: {
    maxWidth: "600px",
  },
  modalLarge: {
    maxWidth: "1024px",
  },
  modalCustom: {
    maxWidth: "310px",
  },
}));
